import { ImportLeadsProvider } from '@crm/features/leads/contexts'
import { ImportLayout } from '@crm/features/leads/layouts'
import { routes } from '@crm/routes/routes'
import { Outlet, useLocation } from 'react-router-dom'

export const LeadImportSteps = () => {
  const { pathname } = useLocation()

  const step = pathname.split('/').pop()
  const steps = routes.find(({ name }) => name === 'LeadImportSteps')?.children

  return (
    step &&
    steps && (
      <ImportLeadsProvider>
        <ImportLayout step={step} steps={steps}>
          <Outlet />
        </ImportLayout>
      </ImportLeadsProvider>
    )
  )
}
